/* eslint-disable no-shadow */
import moment from 'moment';

const state = {
	expiration: moment().add(5, 'minutes').unix(),
	posts: {
		loading: false,
		results: [],
		total: 0,
	},
	pendingPosts: {
		loading: false,
		results: [],
		total: 0,
	},
	tags: {
		loading: false,
		results: [],
		total: 0,
	},
	users: {
		loading: false,
		results: [],
		total: 0,
	},
	comments: {
		loading: false,
		results: [],
		total: 0,
	},
	summaries: {
		loading: false,
		results: [],
		total: 0,
	},
	usersCache: {
		loading: false,
		results: [],
		total: 0,
	},
	tracks: {
		loading: false,
		results: [],
		total: 0,
	},
	coupons: {
		loading: false,
		results: [],
		total: 0,
	},
	pendingCoupons: {
		loading: false,
		results: [],
		total: 0,
	},
	banners: {
		loading: false,
		results: [],
		total: 0,
	},
};

const getters = {
	'data/posts': st => st.posts,
	'data/pendingPosts': st => st.pendingPosts,
	'data/users': st => st.users,
	'data/comments': st => st.comments,
	'data/summaries': st => st.summaries,
	'data/usersCache': st => st.usersCache,
	'data/tags': st => st.tags,
	'data/tracks': st => st.tracks,
	'data/coupons': st => st.coupons,
	'data/pendingCoupons': st => st.pendingCoupons,
	'data/banners': st => st.banners,
};

const mutations = {
	ADD_ITEM(state, { data, type }) {
		state[type].results.unshift(data);
		state[type].total += 1;
	},
	REMOVE_ITEM(state, { id, key = 'id', type }) {
		const index = state[type].results.findIndex(data => data[key] === id);
		if (index > -1) {
			state[type].results.splice(index, 1);
			state[type].total -= 1;
		}
	},
	SET_ITEM(state, { id, key = 'id', data, type }) {
		const index = state[type].results.findIndex(data => data[key] === id);

		if (index > -1) {
			const mergeData = { ...state[type].results[index], ...data };
			state[type].results[index] = mergeData;
		}
	},
	ADD_DATA(state, { data, reset = false, type }) {
		state[type].total = data.total;
		if (reset) {
			state[type].results = [...data.results];
		} else {
			state[type].results.push(...data.results);
		}
	},
	ADD_DATA_FIRST(state, { data, reset = false, type }) {
		state[type].total = data.total;
		if (reset) {
			state[type].results = [...data.results];
		} else {
			state[type].results.unshift(...data.results);
		}
	},
	SET_DATA_LOADING(state, { value, type }) {
		state[type].loading = value;
	},
	CLEAR_ALL_DATA(state) {
		Object.keys(state).forEach((scope) => {
			state[scope] = {
				loading: false,
				results: [],
				total: 0,
			};
		});
	},
};

const actions = {
	// Singular item
	addItem({ commit }, { data, type }) {
		commit('ADD_ITEM', { data, type });
	},
	removeItem({ commit }, { id, key = 'id', type }) {
		commit('REMOVE_ITEM', { id, key, type });
	},
	setItem({ commit }, { id, key = 'id', data, type }) {
		commit('SET_ITEM', { id, key, data, type });
	},
	addData({ commit }, { data, reset = false, type }) {
		commit('ADD_DATA', { data, reset, type });
	},
	addDataFirst({ commit }, { data, reset = false, type }) {
		commit('ADD_DATA_FIRST', { data, reset, type });
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
